import './editable-string-list.scss'

import { faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import { TranslatedString, createTranslatedString, getTranslatedString } from '@skinsoft/types';
import { ReactiveVue } from '@skinsoft/reactive-vue';

declare const config
const FALLBACK_LOCALE = config.fallback_locale

@Component({
    components: {

    },
    props: ['values', 'editMode', 'dataCy'],
    template: require('./editable-string-list.html')
})
export class EditableTranslatedStringList extends ReactiveVue {
    private values: TranslatedString[];
    private modelList: TranslatedString[] = [];
    private dataCy: string
    private locale: string = FALLBACK_LOCALE;

    // Icons
    private trashIcon = faTrash;
    private addIcon = faPlusCircle;

    private getStringValue(value: any) {
        return getTranslatedString(value, this.getAppLocale());
    }

    private getVModel(value: any) {
        return value.translatedString[this.getAppLocale()]
    }

    private onDeleteClick(index: number) {
        this.values.splice(index, 1)
    }

    private onAddClick() {
        this.modelList.push(createTranslatedString(this.getAppLocale(), ""));
    }

    @Watch('values', { immediate: true })
    private onStringListChange() {
        this.modelList = this.values;
        if (!this.modelList[0] || !this.modelList[0].translatedString) {
            this.modelList[0] = createTranslatedString(this.getAppLocale(), "")
        }
        this.locale = this.getAppLocale()
    }
}